module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/assets/locale/ru.json
// module id = 1262
// module chunks = 0